
import React from "react";
import { useAuth } from "@/contexts/auth";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ReagentRequestForm from "@/components/reagentRequests/ReagentRequestForm";
import NotLoggedInMessage from "@/components/auth/NotLoggedInMessage";

const RequestReagentPage: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <div className="container mx-auto px-4 py-8 flex-grow">
        <h1 className="text-3xl font-bold mb-8">Request a Reagent</h1>
        
        {user ? <ReagentRequestForm /> : <NotLoggedInMessage />}
      </div>
      
      <Footer />
    </div>
  );
};

export default RequestReagentPage;
